import { commandActions } from './adminConfig'
import { AdminTable, DashboardImage } from './AdminShared'
import { AdminAuctionBuilder, AdminBidAudit } from './auctions/AdminAuctions'
import { RiskPanel } from './risk/AdminRisk'

export function AdminOverview({ apiToken, auditRows, auctionRows, bidRows, kpis, onRefresh, onSectionChange, orderRows, reports }) {
  const auctionPreview = auctionRows.slice(0, 4)
  const orderPreview = orderRows.slice(0, 4)
  const bidPreview = bidRows.slice(0, 4)
  const auditPreview = auditRows.slice(0, 4)

  return (
    <div className="obc-admin__overview">
      <section className="obc-admin__kpis">
        {kpis.map((kpi) => (
          <article className={`tactical-card obc-admin__kpi is-${kpi.tone}`} key={kpi.label}>
            <span>{kpi.label}</span>
            <strong>{kpi.value}</strong>
            <small>{kpi.note}</small>
          </article>
        ))}
      </section>

      <section className="obc-admin__command-grid">
        {commandActions.map((action) => (
          <button className="tactical-card" type="button" onClick={() => onSectionChange(action.id)} key={action.label}>
            {action.icon}
            <span>{action.label}</span>
            <small>{action.detail}</small>
          </button>
        ))}
      </section>

      <OperationalReports reports={reports} onSectionChange={onSectionChange} />

      <div className="obc-admin__split">
        <AdminAuctionBuilder apiToken={apiToken} onRefresh={onRefresh} />
        <RiskPanel apiToken={apiToken} onRefresh={onRefresh} onSectionChange={onSectionChange} orderRows={orderRows} />
      </div>

      <div className="obc-admin__split obc-admin__split--wide">
        <div>
          <div className="obc-admin__preview-head">
            <div>
              <span>Preview</span>
              <h3>Live Operations Queue</h3>
            </div>
            <button type="button" onClick={() => onSectionChange('auctions')}>View all</button>
          </div>
          <AdminTable title="Live Operations Queue" rows={auctionPreview} columns={['lot', 'type', 'status', 'reserve', 'close']} imageKey="image" ImageComponent={DashboardImage} />
        </div>
        <div>
          <div className="obc-admin__preview-head">
            <div>
              <span>Preview</span>
              <h3>Orders Needing Attention</h3>
            </div>
            <button type="button" onClick={() => onSectionChange('orders')}>View all</button>
          </div>
          <AdminTable title="Orders Needing Attention" rows={orderPreview} columns={['id', 'user', 'status', 'total', 'action']} />
        </div>
      </div>

      {bidPreview.length ? (
        <div>
          <div className="obc-admin__preview-head">
            <div>
              <span>Preview</span>
              <h3>Bid Audit Ledger</h3>
            </div>
            <button type="button" onClick={() => onSectionChange('bids')}>View all</button>
          </div>
          <AdminBidAudit rows={bidPreview} />
        </div>
      ) : null}

      {auditPreview.length ? (
        <div>
          <div className="obc-admin__preview-head">
            <div>
              <span>Preview</span>
              <h3>Recent Admin Activity</h3>
            </div>
            <button type="button" onClick={() => onSectionChange('settings')}>View all</button>
          </div>
          <AdminTable title="Recent Admin Activity" rows={auditPreview} columns={['actor', 'action', 'target', 'summary', 'time']} />
        </div>
      ) : null}
    </div>
  )
}

export function OperationalReports({ reports = [], onSectionChange }) {
  return (
    <section className="obc-admin__report-grid">
      {reports.map((report) => (
        <button
          className={`tactical-card obc-admin__report-card is-${report.tone}`}
          key={report.label}
          type="button"
          onClick={() => onSectionChange(report.section)}
        >
          <span>{report.label}</span>
          <strong>{report.value}</strong>
          <small>{report.note}</small>
        </button>
      ))}
    </section>
  )
}
